module.exports = __webpack_public_path__ + "img/profile-picture-robin-min.9bcd4ead.png";